import { render, staticRenderFns } from "./public-demand.vue?vue&type=template&id=bccaba1e&scoped=true"
import script from "./public-demand.vue?vue&type=script&lang=js"
export * from "./public-demand.vue?vue&type=script&lang=js"
import style0 from "./public-demand.vue?vue&type=style&index=0&id=bccaba1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccaba1e",
  null
  
)

export default component.exports